import { Action, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { HomePageAction, HomePageState } from "@/components/homePage/types";

export const actions: ActionTree<HomePageState, RootState> &
  Record<HomePageAction, Action<HomePageState, RootState>> = {};
